import { render, staticRenderFns } from "./AddServiceRequest.vue?vue&type=template&id=627c8442&"
import script from "./AddServiceRequest.vue?vue&type=script&lang=js&"
export * from "./AddServiceRequest.vue?vue&type=script&lang=js&"
import style0 from "./AddServiceRequest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports